
import SuccessWithRouletteDialog from "../../composant/Popup/PopupRoulleteSucces";
//import { useDispatch } from "react-redux";


export default function RouletteWheel() {
  //const dispatch = useDispatch();
  return (
    <SuccessWithRouletteDialog
      open={true}
      code="00000"
      clientType="fidele"
      idCommande={1}
    />
  );
}
